// <rail-carousel> pages a horizontal snap track with prev/next buttons.
// Contract: [data-rail-track] is the scrolling list; [data-rail-prev] / [data-rail-next] are optional buttons.
// Touch and trackpad scroll natively; buttons scroll by most of the visible width and disable at the ends.
class RailCarousel extends HTMLElement {
  #track = null;
  #prev = null;
  #next = null;
  #abort = null;

  connectedCallback() {
    this.#track = this.querySelector('[data-rail-track]');
    this.#prev = this.querySelector('[data-rail-prev]');
    this.#next = this.querySelector('[data-rail-next]');
    if (!this.#track) return;
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.#prev?.addEventListener('click', () => this.#page(-1), { signal });
    this.#next?.addEventListener('click', () => this.#page(1), { signal });
    this.#track.addEventListener('scroll', () => this.#update(), { passive: true, signal });
    window.addEventListener('resize', () => this.#update(), { passive: true, signal });
    this.#update();
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #page(direction) {
    const rtl = getComputedStyle(this.#track).direction === 'rtl' ? -1 : 1;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollBy({ left: direction * rtl * this.#track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
  }

  #update() {
    const track = this.#track;
    const position = Math.abs(track.scrollLeft);
    const max = track.scrollWidth - track.clientWidth - 2;
    if (this.#prev) this.#prev.disabled = position <= 2;
    if (this.#next) this.#next.disabled = position >= max;
  }
}

if (!customElements.get('rail-carousel')) customElements.define('rail-carousel', RailCarousel);
